import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, timer } from 'rxjs';
import { AlertDetailService } from './alert-detail.service';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-alert-detail',
  templateUrl: './alert-detail.component.html',
  styleUrls: ['./alert-detail.component.scss']
})
export class AlertDetailComponent implements OnInit {

  viewState$: Observable<any>;
  
  constructor(private route: ActivatedRoute, private data: AlertDetailService) { 
  
  }

  ngOnInit() {
    this.viewState$ = timer(0, 10000 /* 2sec */).pipe(
      switchMap(() => this.data.getAlertDetailData(this.route.snapshot.paramMap.get('id')))
    );
  }

}
